import React from 'react'

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="50"
      className=' h-10 w-10'
      fill="none"
      viewBox="0 0 51 50"
    >
      <path
        fill="#EAB300"
        d="M50.287 24.921c0 13.76-11.157 24.917-24.923 24.919C11.608 49.84.451 38.681.454 24.919.448 11.157 11.605 0 25.367 0c13.762 0 24.92 11.159 24.92 24.921z"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M35.173 18.816c-.321-3.337-3.202-4.455-6.842-4.774V9.41h-2.817v4.508c-.74 0-1.498.014-2.25.03V9.41h-2.816l-.002 4.627-.03.001c-.6.012-1.19.023-1.765.023v-.014l-3.885-.002v3.01s2.081-.039 2.045-.001c1.143 0 1.513.662 1.621 1.234v5.275c.08 0 .181.004.297.02h-.297l-.002 7.39c-.05.36-.261.932-1.059.934.036.032-2.047 0-2.047 0l-.56 3.365h3.668c.414 0 .824.005 1.229.009.263.003.524.006.783.007l.002 4.683h2.815v-4.633c.771.016 1.519.022 2.25.022l-.001 4.611h2.817v-4.673c4.737-.271 8.056-1.465 8.467-5.915.333-3.583-1.352-5.184-4.041-5.83 1.636-.829 2.66-2.294 2.42-4.737zM31.23 28.83c0 3.213-5.055 3.14-7.36 3.107a39.232 39.232 0 00-.543-.005v-6.207c.194 0 .431-.005.7-.01 2.37-.054 7.203-.162 7.203 3.115zm-7.432-5.936c1.929.03 6.12.096 6.12-2.819.002-2.983-4.037-2.876-6.011-2.824-.223.006-.419.011-.58.011v5.626c.134 0 .293.003.47.006z"
        clipRule="evenodd"
      ></path>
      <path fill="#fff" d="M18.436 23.44h.419v.309h-.419v-.31z"></path>
    </svg>
  )
}

export default Icon